// 引入 axios
import axios from 'axios'
import router from './index'
// import {config} from '../../static/config/config.js'

// 封装 baseURL
const request = axios.create({
    // 请求总地址
    baseURL: 'https://api.ixushan.com',
    // 超出时常
    // timeout: 25000,
    // 请求头(默认请求头)
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    headers: {
        "Content-Type": "application/json"
    },
    // 请求类型
    method: 'POST'
})

// 拦截器对数据做处理
request.interceptors.response.use(
    response => {
        const res = response.data
        // if (res.message === '用户未登录TK无效') {
        //     // this.message.error('账号已过期请重新登录')
        //     router.push('/');
        //     return
        // }
        if (res == null || res === '') {

            return '后台返回失败'
        } else if (res == null) {
            return {
                code: 20001,
                data: {},
                message: '方法异常',
                success: false
            }
        } else {
            return res
        }
    },

    error => {
        return '未知的错误' + error
    }
)
// 向外暴露 request
export default request;